import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HolidayScreen from "./Components/Holiday/HolidayScreen";
import HolidayPackageDetails from "./Components/Holiday/HolidayPackageDetails";
import HotelSearch from "./Components/Hotels/HotelSearch";
import SearchSightSeeing from "./Components/SightSeeings/SearchSightSeeing";
import B2CLayout from "./Components/Profile/B2CLayout";
import DestinationPackages from "./Components/Holiday/PackageByDestination";
import FlightSearch from "./Components/Flight/SearchFlight";
import Flights from "./Components/Flight/Flights";
import FlightDetails from "./Components/Flight/FlightDetails";
import ReviewFlight from "./Components/Flight/ReviewFlight";
import FlightBookings from "./Components/Flight/FlightBookings";
import FlightBookingDetails from "./Components/Flight/FlightBookingDetails";
import FlightVoucher from "./Components/Flight/FlightVoucher";
import FlightInvoice from "./Components/Flight/FlightInvoice";
import HotelsList from "./Components/Hotels/HotelsList";
import HotelDetails from "./Components/Hotels/HotelDetails";
import HotelGuests from "./Components/Hotels/HotelGuests";
import HotelReview from "./Components/Hotels/HotelReview";
import HotelBookings from "./Components/Hotels/HotelBookings";
import HotelBookingDetails from "./Components/Hotels/HotelBookingDetails";
import HotelVoucher from "./Components/Hotels/HotelVoucher";
import HotelInvoice from "./Components/Hotels/HotelInvoice";
import SightSeeingProducts from "./Components/SightSeeings/SightSeeingProducts";
import SightSeeingProduct from "./Components/SightSeeings/SightSeeingProduct";
import AboutUs from "./CompanyData/StaticPages/AboutUs";
import TermsAndConditions from "./CompanyData/StaticPages/Terms";
import Faq from "./CompanyData/StaticPages/Faq";
import PrivacyPolicy from "./CompanyData/StaticPages/PrivacyPolicy";
import RefundPolicy from "./CompanyData/StaticPages/RefundPolicy";
import ContactUs from "./CompanyData/StaticPages/ContactUs";
import AccountLayout from "./Components/Profile/AccountLayout";
import MyProfilePage from "./Components/Profile/MyProfilePage";
import MyFlightBookings from "./Components/Bookings/MyFlightBookings";
import MyFlightBookingDetails from "./Components/Bookings/MyFlightBookingDetails";
import HolidayResults from "./Components/Holiday/HolidayResults";
import UmrahPackageDetails from "./Components/Umrah/UmrahDetails";
import UmrahScreen from "./Components/Umrah/UmrahScreen";
import UmrahResults from "./Components/Umrah/UmrahResult";
import TravelTypeResults from "./Components/Holiday/PackagesByTravelType";
import HajjScreen from "./Components/Hajj/HajjScreen";
import HajjDetails from "./Components/Hajj/HajjDetails";
import HajjResults from "./Components/Hajj/HajjResut";
import MyHotelBookings from "./Components/Bookings/MyHotelBookings";
import MyHotelBookingDetails from "./Components/Bookings/MyHotelBookingDetails";

import Template_1_HomePage from "./Templates/Template_1/Template_1_HomePage";
import Template_1_PackageDetails from "./Templates/Template_1/Template_1_PackageDetails";
import Template_2_HomePage from "./Templates/Template_2/Template_2_HomePage";
import Template_2_PackageDetails from "./Templates/Template_2/Template_2_PackageDetails";
import Template_3_HomePage from "./Templates/Template_3/Template_3_HomePage";
import Template_3_PackageDetails from "./Templates/Template_3/Template_3_PackageDetails";
import Template_2_Destinations from "./Templates/Template_2/Template_2_Destinations";
import ResetPassword from "./Authentication/ResetPassword";
import SightSeeingBooking from "./Components/SightSeeings/SightSeeingBooking";
import SightSeeingBookingDetails from "./Components/SightSeeings/SightSeeingBookingDetails";
import SightSeeingBookings from "./Components/SightSeeings/SightSeeingBookings";
import BusSearch from "./Components/Bus/SearchBus.jsx";
import BusResults from "./Components/Bus/BusResults.jsx";
import BookingDetails from "./Components/Bus/BookingDetails.jsx";
import BusPayment from "./Components/Bus/BusPayment.jsx";
import BusBookingConfirmation from "./Components/Bus/BusBookingConfirmation.jsx";
import BusSeatSelection from "./Components/Bus/BusSeatSelection.jsx";
import MyBusBookings from "./Components/Bookings/MyBusBookings.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route path="/template_1_homepage" element={<Template_1_HomePage />} />
        <Route
          path="/template_1_packagedetails/:packageId"
          element={<Template_1_PackageDetails />}
        />

        <Route path="/template_2_homepage" element={<Template_2_HomePage />} />
        <Route
          path="/template_2_packagedetails/:packageId"
          element={<Template_2_PackageDetails />}
        />
        <Route
          path="/template_2_destinations"
          element={<Template_2_Destinations />}
        />
        <Route path="/template_3_homepage" element={<Template_3_HomePage />} />
        <Route
          path="/template_3_packagedetails/:packageId"
          element={<Template_3_PackageDetails />}
        />
       <Route path="/resetpassword" element={<ResetPassword />} />
        <Route element={<B2CLayout />}>
          <Route path="/" element={<FlightSearch />} />
          <Route path="/flight/search" element={<FlightSearch />} />
          <Route
            path="/flight/:adults?/:kids?/:infants?/:isDomestic?"
            element={<Flights />}
          />
          <Route
            path="/flightdetails/:adults?/:kids?/:infants?/:isDomestic?"
            element={<FlightDetails />}
          />
          <Route
            path="/flight/review/:adults?/:kids?/:infants?/:isDomestic?"
            element={<ReviewFlight />}
          />
          <Route path="/flight/bookings" element={<FlightBookings />} />
          <Route
            path="/flight/booking/:flightBookingId"
            element={<FlightBookingDetails />}
          />
          <Route
            path="/flight/voucher/:flightBookingId"
            element={<FlightVoucher />}
          />
          <Route
            path="/flight/invoice/:flightBookingId"
            element={<FlightInvoice />}
          />

          <Route path="/hotel/search" element={<HotelSearch />} />
          <Route path="/hotels" element={<HotelsList />} />
          <Route path="/hotel/details/:hotelId?" element={<HotelDetails />} />
          <Route path="/hotel/guests" element={<HotelGuests />} />
          <Route path="/hotel/review" element={<HotelReview />} />
          <Route path="/hotel/bookings" element={<HotelBookings />} />
          <Route
            path="/hotel/booking/:hotelBookingId"
            element={<HotelBookingDetails />}
          />
          <Route
            path="/hotel/voucher/:hotelBookingId"
            element={<HotelVoucher />}
          />
          <Route
            path="/hotel/invoice/:hotelBookingId"
            element={<HotelInvoice />}
          />

          <Route path="/holidays" element={<HolidayScreen />} />
          <Route
            path="/holiday-details/:packageId"
            element={<HolidayPackageDetails />}
          />
          <Route path="/holidays/search" element={<HolidayResults />} />
          <Route
            path="/packages/type/:travelTypeName"
            element={<TravelTypeResults />}
          />

          <Route path="/search/sightseeing" element={<SearchSightSeeing />} />
          <Route
            path="/sightseeing/products/:destinationCode/:destination/:adults?/:kids?/:travelDate"
            element={<SightSeeingProducts />}
          />
          <Route
            path="/sightseeing/product/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate"
            element={<SightSeeingProduct />}
          />
           <Route
            path="/sightseeing/booking/:productId/:destinationCode/:destination/:adults?/:kids?/:travelDate"
            element={<SightSeeingBooking />}
          />
          <Route
            path="/sightseeing/booking/:sightSeeingBookingId"
            element={<SightSeeingBookingDetails />}
          />
          <Route
            path="/sightseeing/bookings"
            element={<SightSeeingBookings />}
          />
          <Route
            path="/destination/:destinationId"
            element={<DestinationPackages />}
          />

          <Route path="/umrahs" element={<UmrahScreen />} />
          <Route
            path="/umrah-details/:packageId"
            element={<UmrahPackageDetails />}
          />
          <Route path="/umrah-packages/search" element={<UmrahResults />} />

          <Route path="/hajj" element={<HajjScreen />} />
          <Route path="/hajj-details/:packageId" element={<HajjDetails />} />
          <Route path="/hajj-packages/search" element={<HajjResults />} />

          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="contact-us" element={<ContactUs />} />

          <Route path="/bus/search" element={<BusSearch />} />
          <Route path="/bus/results" element={<BusResults />} />
          <Route path="/bus/seats" element={<BusSeatSelection />} />
          <Route path="/bus/payment" element={<BusPayment />} />
          <Route
            path="/bus/booking-confirmation"
            element={<BusBookingConfirmation />}
          />

          <Route path="/bus/booking/:bookingId" element={<BookingDetails />} />
          <Route element={<AccountLayout />}>
            <Route path="/my-profile" element={<MyProfilePage />} />
            <Route path="/my-flightbookings" element={<MyFlightBookings />} />
            <Route
              path="/my-flight/booking/:flightBookingId"
              element={<MyFlightBookingDetails />}
            />
            <Route path="/my-hotelbookings" element={<MyHotelBookings />} />
            <Route
              path="/my-hotel/booking/:hotelBookingId"
              element={<MyHotelBookingDetails />}
            />
            <Route path="/my-sightseeingbookings" element={<SightSeeingBookings />} />
            <Route
              path="/my-sightseeing/booking/:sightSeeingBookingId"
              element={<SightSeeingBookingDetails />}
            />
            <Route path="/my-busbookings" element={<MyBusBookings />} />
            <Route path="/bus/booking/:bookingId" element={<BookingDetails />} />
          </Route>
        </Route>
        {/*B2C END*/}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
